import { c as _c } from "react/compiler-runtime";
import { usePageView } from '@/analytics/pageTypes';
import { SeoHeader } from '@/components/SeoHeader';
import { Layout } from '@/components/layout';
import Hero from '@/sections/Hero';
import { getIntlProps, type IntlProps } from '@/utils/intl';
import type { GetStaticProps } from 'next';
import { Trans, useTranslation } from 'react-i18next';
import React from 'react';
import { MoreInfo } from '@/sections/springOffer/MoreInfo';
import { Gifts } from '@/sections/springOffer/Gifts';
import { HowItWorks } from '@/sections/springOffer/HowItWorks';
import { Sales } from '@/sections/springOffer/Sales';
import { Faqs } from '@/sections/springOffer/Faqs';
import { getPageBannerWithPromoSourceBySlug, PageBanner } from '@/api/sanity/pageBanners';
import { EshopsList, getAffiliateEshopsList } from '@/api/sanity/affiliateEshopsList';
import { AnimatedSection, AnimatedContent } from '@/components/animation';
import { LINKS } from '@/constants/links';
import Eshops from '@/sections/Eshops';
import { Link } from '@/components/links';
import usePromoSource from '@/hooks/usePromoSource';
import { useClientOnly } from '@/hooks/useClientOnly';
import { isAllowedRoute } from '@/lang/pagesConfig';
import { RepresentativeExample } from '@/sections/RepresentativeExample';
import { getAllPageMenuPromoBanners, PageMenuPromoBanner } from '@/api/sanity/pageMenuPromoBanner';
import { SPRING_OFFER_TRANSLATION_VALUES } from '@/constants/springOffer';
import { getSectionAnchorId } from '@/utils/anchors';
import { useProductRegistrationLink } from '@/hooks/useProductRegistrationLink';
interface Props extends IntlProps {
  pageBanners: PageBanner[] | null;
  eshops: EshopsList;
  menuPromoBanners?: PageMenuPromoBanner[];
}
export default function Page(t0) {
  const $ = _c(54);
  const {
    pageBanners,
    eshops,
    menuPromoBanners
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["springOffer", "core"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  const promoSource = usePromoSource();
  const {
    isClient
  } = useClientOnly();
  const registrationLink = useProductRegistrationLink("jaro2026");
  usePageView("spring-offer");
  let t2;
  if ($[1] !== isClient || $[2] !== pageBanners || $[3] !== promoSource) {
    t2 = isClient && promoSource && pageBanners?.find(banner_0 => banner_0.promoSource === promoSource) || pageBanners?.find(_temp);
    $[1] = isClient;
    $[2] = pageBanners;
    $[3] = promoSource;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const pageBanner = t2;
  let t3;
  if ($[5] !== t) {
    t3 = t("spring.seo.title");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("spring.seo.description", SPRING_OFFER_TRANSLATION_VALUES);
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <SeoHeader title={t3} description={t4} />;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const t6 = pageBanner?.videoId;
  let t7;
  if ($[12] !== pageBanner?.title || $[13] !== t) {
    t7 = pageBanner?.title ?? t("spring.banner.title");
    $[12] = pageBanner?.title;
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== pageBanner?.text || $[16] !== t) {
    t8 = pageBanner?.text ?? <Trans t={t} i18nKey="spring.banner.text"><Link testId="springShopWisely" analyticsParam="springShopWisely" to={LINKS().shopWisely} /></Trans>;
    $[15] = pageBanner?.text;
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== pageBanner || $[19] !== registrationLink || $[20] !== t) {
    t9 = pageBanner ? pageBanner.buttons : [{
      ariaLabel: t("spring.banner.cta"),
      label: t("spring.banner.cta"),
      to: registrationLink,
      testId: "springCta",
      analyticsParam: "springCta",
      variant: "primary"
    }];
    $[18] = pageBanner;
    $[19] = registrationLink;
    $[20] = t;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  const t10 = pageBanner?.variant || "mockupMobile";
  const t11 = pageBanner?.image?.url ?? "/images/sections/spring/hero/cs/hero.png";
  let t12;
  if ($[22] !== pageBanner?.image?.alt || $[23] !== t) {
    t12 = pageBanner?.image?.alt ?? t("spring.banner.title");
    $[22] = pageBanner?.image?.alt;
    $[23] = t;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t11 || $[26] !== t12) {
    t13 = {
      url: t11,
      alt: t12
    };
    $[25] = t11;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t10 || $[29] !== t13 || $[30] !== t6 || $[31] !== t7 || $[32] !== t8 || $[33] !== t9) {
    t14 = <Hero videoId={t6} title={t7} text={t8} buttons={t9} variant={t10} image={t13} />;
    $[28] = t10;
    $[29] = t13;
    $[30] = t6;
    $[31] = t7;
    $[32] = t8;
    $[33] = t9;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = getSectionAnchorId("offer");
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <AnimatedContent><Gifts /></AnimatedContent>;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <AnimatedContent><HowItWorks /></AnimatedContent>;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <div className="mx-auto max-w-192"><AnimatedContent><RepresentativeExample /></AnimatedContent></div>;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <AnimatedSection bgColor="bg-blue-100" className="flex flex-col gap-20 lg:gap-40" id={t15}>{t16}{t17}{t18}<AnimatedContent><Sales /></AnimatedContent></AnimatedSection>;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = getSectionAnchorId("eshops");
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== eshops || $[42] !== t) {
    t21 = eshops.length > 0 && <Eshops eshops={eshops} title={t("spring.eshopList")} hideText={true} />;
    $[41] = eshops;
    $[42] = t;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  let t22;
  if ($[44] !== t21) {
    t22 = <AnimatedSection bgColor="bg-blue-50" id={t20}><AnimatedContent><div>{t21}</div></AnimatedContent></AnimatedSection>;
    $[44] = t21;
    $[45] = t22;
  } else {
    t22 = $[45];
  }
  let t23;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = getSectionAnchorId("moreInfo");
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  let t24;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <AnimatedContent><Faqs /></AnimatedContent>;
    $[47] = t24;
  } else {
    t24 = $[47];
  }
  let t25;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <AnimatedSection bgColor="bg-blue-100" className="flex flex-col gap-20 lg:gap-40" id={t23}>{t24}<AnimatedContent><MoreInfo /></AnimatedContent></AnimatedSection>;
    $[48] = t25;
  } else {
    t25 = $[48];
  }
  let t26;
  if ($[49] !== menuPromoBanners || $[50] !== t14 || $[51] !== t22 || $[52] !== t5) {
    t26 = <Layout menuPromoBanners={menuPromoBanners}>{t5}{t14}{t19}{t22}{t25}</Layout>;
    $[49] = menuPromoBanners;
    $[50] = t14;
    $[51] = t22;
    $[52] = t5;
    $[53] = t26;
  } else {
    t26 = $[53];
  }
  return t26;
}
function _temp(banner) {
  return !banner.promoSource;
}
export const getStaticProps = (async ctx => {
  const isAllowed = isAllowedRoute('my-to-platime');
  if (!isAllowed) {
    return {
      notFound: true
    };
  }
  return {
    props: {
      pageBanners: await getPageBannerWithPromoSourceBySlug('spring-offer'),
      eshops: await getAffiliateEshopsList('springOffer'),
      menuPromoBanners: await getAllPageMenuPromoBanners(),
      ...(await getIntlProps(ctx, ['core', 'eshops', 'springOffer']))
    }
  };
}) satisfies GetStaticProps<Props>;